<template>
  <b-row>
    <b-col cols="12">
      <destinations-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import DestinationsTable from './DestinationsTable.vue'

export default {
  components: {
    BRow,
    BCol,

    DestinationsTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>

